(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-experts"] && !Shopify.designMode) return;
  try {
    

// document.addEventListener('DOMContentLoaded', function () {
//   const readMoreBtns = document.querySelectorAll('.read-more-btn'); // Get all buttons (in case there are multiple instances)

//   readMoreBtns.forEach(function(readMoreBtn) {
//     const moreText = readMoreBtn.previousElementSibling; // Get the corresponding .more-text element

//     readMoreBtn.addEventListener('click', function () {
//       // Toggle the 'hidden' class on the more-text div
//       moreText.classList.toggle('hidden');
      
//       // Change the button text based on the visibility of more-text
//       if (moreText.classList.contains('hidden')) {
//         readMoreBtn.textContent = 'read more';
//       } else {
//         readMoreBtn.textContent = ' read less';
//       }
//     });
//   });
// });

// document.querySelector('.read-more-btn').addEventListener('click', function() {
//   const description = document.querySelector('.more-text');
//   description.classList.toggle('expanded');

//   // Toggle the text of the "Read More" link
//   this.textContent = description.classList.contains('expanded') ? 'read less' : 'read more';
// });







// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.mosaic__item__btn').forEach(btn => {
//     btn.addEventListener('click', function() {
//       const parent = this.closest('.mosaic__item__buttons');
      
//       if (parent) {
//         parent.classList.add('hide_div');
//         const sibling = Array.from(parent.parentElement.children).find(child => 
//           child !== parent && child.classList.contains('mosaic__grid')
//         );
        
//         if (sibling) {
//           sibling.classList.add('show_all_experts');
//         }
//       }
//     });
//   });
// });


  
  

  } catch(e) { console.error(e); }
})();
})();
